export default {
  name: 'Captcha',
  props: {
    value: Object | Array,
    disabled: Boolean,
    maxretries: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      content: {
        key: null,
        value: ''
      },
      loading: false
    };
  },
  methods: {
    resetCaptcha (captcha) {
      this.content.key = captcha.key;
      this.content.img = captcha.img;
      this.content.visible = captcha.visible;
      this.content.value = '';
      this.updateValue();
    },
    updateValue () {
      this.$emit('input', this.content)
    },
    getCaptcha () {
      const self = this;
      this.loading = true;
      this.ApiRequest.request('captcha?maxretries=' + this.maxretries, this.ApiRequest.REQUEST_GET, {}, function (response) {
        if (response.captcha) {
          self.content.key = response.captcha.key;
          self.content.img = response.captcha.img;
          self.content.visible = response.captcha.visible;
          self.content.value = '';
          self.loading = false;
          self.updateValue();
        }
      });
    }
  },
  mounted () {
    this.getCaptcha();
  }
}
